import React from 'react'

import {
  Layout,
  Header,
  Section,
  Grid,
  GridItem,
  Intro,
  SectionTitle,
  ItemTitle,
  SmallTitle,
  Paragraph,
} from '../../../../components'

import './style.scss'
import data from './data.json'

import assPan from '../../../../images/Assets-Panel.png'
import editTool from '../../../../images/Editor-Toolbar.png'
import EnableMT from '../../../../images/Enable-WT.png'
import UpToast from '../../../../images/Update-Toast.png'
import LibIcon from '../../../../images/Library-Icon.png'
import PlaceWT from '../../../../images/Place-Asset-WT.png'
import SetVarWT from '../../../../images/Set-Variant-WT.png'
import SetStyleWT from '../../../../images/Set-Style-WT.png'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        subtitle={data.subtitle}
        slug={data.slug + '/design/'}
        site={data.site}
        state="design"
        title="Start Designing"
        complete={true}
      >
        <Intro noBorder={true}>
          <p>
            Currency components are a collection of interface elements that can
            be reused across M&T Bank and Wilmington Trust's digital products.
            Components can be combined to create user interfaces consistent with
            the bank’s principles, design language and best practices.
          </p>
          <p>
            If you are new to Currency, explore the <strong>Guidelines</strong>{' '}
            to learn the M&T and Wilmington Trust product design principles. To
            familiarize yourself with the existing assets which you can
            incorporate into your designs, review the{' '}
            <strong>Components</strong> and <strong>Patterns</strong> sections.
          </p>
        </Intro>

        <Section type="gray">
          <Grid>
            <GridItem columns="12">
              <SectionTitle>Software</SectionTitle>
            </GridItem>
            <GridItem columns="6">
              <ItemTitle>Figma</ItemTitle>
              <Paragraph size="large">
                Currency uses{' '}
                <a className="link" href="//figma.com">
                  Figma
                </a>{' '}
                to manage design tokens and assets. This is the same platform
                that designers will use to create and share designs and
                prototypes.
              </Paragraph>
            </GridItem>
            <GridItem columns="6">
              <ItemTitle>Web or Browser Applications</ItemTitle>
              <Paragraph size="large">
                Figma can be accessed via the web app or the desktop app and
                needs an active internet connection to connect to the Currency
                Design System.
              </Paragraph>
            </GridItem>
          </Grid>
        </Section>
        <Section className="l-padding-vertical--xxlarge">
          <SectionTitle>Using the Currency Figma Library</SectionTitle>
          <Paragraph size="medium">
            The Wilmington Trust Currency Design System library is available to
            all members of the M&T Figma organization. You can enable which
            libraries automatically show up in your draft files in your user
            settings.
          </Paragraph>
          <img alt="Enable libraries in drafts" src={EnableMT} width="85%" />
          <ItemTitle className="l-padding-vertical--large">
            Accessing the library within a file
          </ItemTitle>
          <Grid>
            <GridItem columns="6">
              <p>From the Assets Panel</p>
              <img alt="Assets Panel Library Modal" src={assPan} />
            </GridItem>
            <GridItem columns="6">
              <p>From the Editor Toolbar</p>
              <img alt="Editor Toolbar Library Modal" src={editTool} />
            </GridItem>
          </Grid>
          <ItemTitle>Syncing your library</ItemTitle>
          <Paragraph size="medium">
            In Figma, you can immediately sync Currency library changes straight
            to your working files. When new components or styles are added, or
            when existing components and styles{' '}
            <strong>within your file</strong> are changed, a notification will
            appear in the bottom-right corner of your screen.
          </Paragraph>
          <img alt="Update Toast" src={UpToast} width="40%" />{' '}
          <Paragraph>
            You can review the changes made to the components and accept them,
            or dismiss the notification. It will appear every time you open an
            affected file.
          </Paragraph>
          <Paragraph>
            You can also update the Currency library from the libraries modal.
            There will be a blue notification dot on the libraries icon{' '}
            <img alt="Library Icon" src={LibIcon} /> to alert you of updates.
            Assets you choose not to update will still be connected to the main
            Currency instance. You can choose to update at any time.
            {/* <img alt="Update Dot" src={UpChip} /> */}
          </Paragraph>
          <hr className="l-margin-top--xxlarge" />
          <SectionTitle>
            <span class="unbold">Placing</span> assets
          </SectionTitle>
          <Grid>
            <GridItem columns="4">
              <Grid>
                <GridItem columns="12">
                  <SmallTitle>One</SmallTitle>
                  <Paragraph size="small">
                    Click on the Assets tab in the left sidebar or use the
                    keyboard shortcut Option + 2. Make sure the Currency Library
                    is enabled from the{' '}
                    <img
                      alt="Libraries Icon"
                      src={LibIcon}
                      class="u-display--inline"
                    />{' '}
                    libraries modal.
                  </Paragraph>
                </GridItem>

                <GridItem columns="12">
                  <SmallTitle>Two</SmallTitle>
                  <Paragraph size="small">
                    Search for the base instance of your desired asset, e.g.
                    "Button".
                  </Paragraph>
                </GridItem>
                <GridItem columns="12">
                  <SmallTitle>Three</SmallTitle>
                  <Paragraph size="small">
                    Drag the asset onto your canvas. The asset will now appear
                    in your local "Used in this file" category.
                  </Paragraph>
                </GridItem>
              </Grid>
            </GridItem>
            <GridItem columns="8">
              <img
                alt="Placing an asset"
                src={PlaceWT}
                className="l-margin-left--xlarge"
              />
            </GridItem>
          </Grid>
          <hr className="l-margin-top--xxlarge" />
          <SectionTitle>
            <span class="unbold">Setting</span> variants and states
          </SectionTitle>
          <Grid>
            <GridItem columns="4">
              <Grid>
                <GridItem columns="12">
                  <Paragraph size="small">
                    To change the variant, state, size or any other variable
                    properties of the base asset select the asset and edit the
                    properties in the Design tab of the right panel.
                  </Paragraph>
                </GridItem>
              </Grid>
            </GridItem>
            <GridItem columns="8">
              <img
                alt="Setting asset variants"
                src={SetVarWT}
                className="l-margin-left--xlarge"
              />
            </GridItem>
          </Grid>
          <hr className="l-margin-top--xxlarge" />
          <SectionTitle>
            <span class="unbold">Placing</span> Text, Grids, Colors and Styles
          </SectionTitle>
          <Paragraph>
            In Figma, foundational elements like text, grids, fills and shadows
            are called Styles. Unlike DSM, styles are not discreet assets that
            you can drag into your file. Instead, they are properties that can
            be applied to any assets you create. All styles are adjusted in the
            Design tab of the right panel.
          </Paragraph>
          <Grid>
            <GridItem columns="4">
              <Grid>
                <GridItem columns="12">
                  <SmallTitle>One</SmallTitle>
                  <Paragraph size="small">
                    Select the asset you want to apply styles to from the canvas
                    or from the Layers tab of the left panel.
                  </Paragraph>
                </GridItem>
                <GridItem columns="12">
                  <SmallTitle>Two</SmallTitle>
                  <Paragraph size="small">
                    In the Design tab of the right panel, click the four dots on
                    the right side of the appropriate section to access the
                    Currency library styles. For shadows, simply click the plus
                    icon.
                  </Paragraph>
                </GridItem>
                <GridItem columns="12">
                  <SmallTitle>Three</SmallTitle>
                  <Paragraph size="small">
                    Select the style you want to apply to the element.
                  </Paragraph>
                </GridItem>
              </Grid>
            </GridItem>
            <GridItem columns="8">
              <img
                alt="Setting Styles"
                src={SetStyleWT}
                className="l-margin-left--xlarge"
              />
            </GridItem>
          </Grid>
        </Section>
      </Layout>
    </>
  )
}
